export default __webpack_public_path__ + "static/media/error.d9f9c7b6.svg";